import React, { useEffect, useState } from "react";
import * as S from './styles';

import IconDoc from "../../assets/icons/icon-doc-gray.png";
import IconClock from "../../assets/icons/icon-clock-blue.png";
import IconWarning from "../../assets/icons/icon-warning-orange.png";
import { BodyG, H6, TaglineM, TaglineP } from "../../styles/stylesTypography";
import { theme } from "../../styles/theme";
import { useCulture } from '../../contexts/CultureContext';

const LastRecipes = ({allRecipes, culturas, updateCultura, maxWidth}) => {
  const [width, setWidth] = useState(window.innerWidth);
  const { selectedCulture, setSelectedCulture } = useCulture();
  const recipes = Array.isArray(allRecipes) ? allRecipes : [];
  const cultures = Array.isArray(culturas) ? culturas : [];
  const hasRecipes = recipes.length > 0;
  const hasCultures = cultures.length > 0;

  const handleCultureChange = (e) => {
    setSelectedCulture(e.target.value);
    updateCultura(e.target.value);
  };

  function formatarData(dataISO) {
    const data = new Date(dataISO);
    const dia = data.getUTCDate().toString().padStart(2, '0');
    const mes = data
      .toLocaleString('pt-BR', { month: 'short', timeZone: 'UTC' })
      .toUpperCase();
    const ano = data.getUTCFullYear();

    return `${dia} ${mes} ${ano}`;
  }

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <S.Container maxWidth={maxWidth}>
      <S.HeaderContainer>

        <S.ContainerWrapperPrimary>
          <BodyG color={theme.colors.gray.Cinza_2} fontWeight={700}>
            Últimas receitas
          </BodyG>

          {hasCultures && (
            <S.CultureSelector value={selectedCulture} onChange={handleCultureChange}>
              <option value="*">{width < 760 ? "Filtrar cultura" : "Selecionar cultura"}</option>

              {cultures.map((c, i) => (
                <option key={`op_${c.value}_${i}`} value={`${c.value}`}>{c.label}</option>
              ))}
            </S.CultureSelector>
          )}
        </S.ContainerWrapperPrimary>

        {(hasRecipes || hasCultures) && (
          <S.ContainerWrapperSecondary>
            <a href="/historico">
              <img src={IconClock} alt="Ícone de relógio" style={{width: "16px", height: "auto"}} />

              <TaglineM color={theme.colors.blue.Azul_link} fontWeight={800} cursor="pointer">
                {width < 760 ? "Histórico" : "Ver Histórico"}
              </TaglineM>
            </a>

            <S.NewRecipe onClick={() => (window.location = "/receitas/add")}>
              <img src={IconDoc} alt="Ícone de Documento" style={{width: "16px", height: "auto"}} />

              <TaglineM color={theme.colors.gray.Cinza_2} fontWeight={800} cursor="pointer">
                {width < 760 ? "Emitir receita" : "Emitir nova receita"}
              </TaglineM>
            </S.NewRecipe>
          </S.ContainerWrapperSecondary>
        )}

      </S.HeaderContainer>

      <S.BoxesWrapper>
        {hasRecipes ? (
          recipes.map((data, index) => {
            const isHomolog = data.homologado;

            return (
              <S.Boxes key={`prescript_${data.id}_${index}`} onClick={() => window.open(data.receita_pdf, "_blank")}>
                <S.HeaderBoxes>
                  <H6 color={theme.colors.gray.Cinza_2} cursor="pointer">
                    {data.agro_prescriptions_relations[0].nome_comercial}
                  </H6>

                  {!isHomolog && <img src={IconWarning} alt="Ícone de aviso" width={16} height={16} />}
                </S.HeaderBoxes>

                <S.FooterBoxes>
                  <S.ProfilePlaceholder>
                    {data.produtor_nome
                      .split(" ")
                      .map((word) => word[0])
                      .join("")
                      .slice(0, 2)
                      .toUpperCase()}
                  </S.ProfilePlaceholder>

                  <TaglineP color={theme.colors.gray.Cinza_2} cursor="pointer">
                    {formatarData(data.data_emissao)}
                  </TaglineP>
                </S.FooterBoxes>
              </S.Boxes>
            );
          })
        ) : (
          <S.NewRecipe onClick={() => (window.location = "/receitas/add")}>
            <img src={IconDoc} alt="Ícone de Documento" style={{width: "16px", height: "auto"}}/>
            <TaglineM color={theme.colors.gray.Cinza_2} fontWeight={800} cursor="pointer">
              Emitir nova receita
            </TaglineM>
          </S.NewRecipe>
        )}
      </S.BoxesWrapper>
    </S.Container>
  );
};

export default LastRecipes;
